import React from 'react';
import { useTranslation } from 'react-i18next';
import { useOutletContext } from 'react-router-dom';
import HeroSection from '../../components/public/home/HeroSection';
import SocialProofSection from '../../components/public/home/SocialProofSection';
import FeaturesSection from '../../components/public/home/FeaturesSection';
import HowItWorksSection from '../../components/public/home/HowItWorksSection';
import TestimonialsSection from '../../components/public/home/TestimonialsSection';
import FAQSection from '../../components/public/home/FAQSection';
import CTASection from '../../components/public/home/CTASection';
import SeoMeta from '../../components/common/SeoMeta';

const HomePage = () => {
  const { t } = useTranslation();
  const { onLoginClick } = useOutletContext() || {};
  const canonicalUrl = 'https://waggy.com.es/';
  const title = t('public.home.title', 'Waggy — Pet Store & Veterinary Management Software');
  const description = t('public.home.description', 'Waggy is an all-in-one management platform for pet stores and veterinary teams. Manage inventory, sales, pets, daycare and grooming from one simple dashboard.');

  const schemas = [
    {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: 'Waggy',
      url: 'https://waggy.com.es',
      logo: 'https://waggy.com.es/logo512.png',
    },
    {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: 'Waggy',
      url: 'https://waggy.com.es',
      inLanguage: ['en', 'es'],
    },
    {
      '@context': 'https://schema.org',
      '@type': 'SoftwareApplication',
      name: 'Waggy',
      applicationCategory: 'BusinessApplication',
      operatingSystem: 'Web',
      url: canonicalUrl,
      description,
      offers: {
        '@type': 'Offer',
        price: '0',
        priceCurrency: 'EUR',
      },
    },
  ];

  return (
    <>
      <SeoMeta
        title={title}
        description={description}
        canonicalUrl={canonicalUrl}
        schemas={schemas}
      />

      <HeroSection onLoginClick={onLoginClick} />
      <SocialProofSection />
      <FeaturesSection />
      <HowItWorksSection />
      <TestimonialsSection />
      <FAQSection />
      <CTASection onLoginClick={onLoginClick} />
    </>
  );
};

export default HomePage;
